import { Route } from '@angular/router';
import { Public } from './public';
export const publicRoutes: Route[] = [
  {
    path: '',
    component: Public,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./authentication/authentication').then(
            (m) => m.Authentication
          ),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },

  // {
  //   path: '**',
  //   redirectTo: 'secure/dashboard',
  // },
];
